export default "__VITE_ASSET__BCGrMyXy__"